import { render, staticRenderFns } from "./TableJudgesSelEditComponent.vue?vue&type=template&id=0d7ad2ee"
import script from "./TableJudgesSelEditComponent.vue?vue&type=script&lang=js"
export * from "./TableJudgesSelEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports